import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ConversationEventProvider } from '../../../../../../data/message/domain/events/conversation/conversation_event_provider';
import { ConversationRead } from '../../../../../../data/message/domain/events/conversation/conversation_events';
import { ConversationModel } from '../../../../../components/message/message.models';
import { QuestionsService } from '../../questions.service';
import { QuestionsListFacade } from './questions-list.facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-questions-list',
  templateUrl: './questions-list.component.html',
  styleUrls: ['./questions-list.component.scss'],
  providers: [QuestionsListFacade],
})
export class QuestionsListComponent implements OnInit, OnDestroy {
  public isLoading = false;
  public error?: string;
  public isUpdating = false;
  public patientId: string;
  private selectedSortListTypeSubscription?: Subscription;
  private selectedGroupSubscription?: Subscription;
  public conversations: ConversationModel[];

  private conversationEventProviderSub: Subscription;

  constructor(
    private facade: QuestionsListFacade,
    private questionsService: QuestionsService,
    private conversationEventProvider: ConversationEventProvider,
  ) {
    this.conversationEventProviderSub =
      this.conversationEventProvider.events$.subscribe((event) => {
        if (event instanceof ConversationRead) {
          this.loadConversations();
        }
      });

    this.selectedGroupSubscription =
      this.questionsService.selectedGroupEmitter.subscribe(() => {
        this.loadConversations();
      });

    this.selectedSortListTypeSubscription =
      this.questionsService.selectedSortListTypeEmitter.subscribe(() => {
        this.loadConversations();
      });
  }

  ngOnDestroy(): void {
    this.selectedSortListTypeSubscription?.unsubscribe();
    this.selectedGroupSubscription?.unsubscribe();
    this.conversationEventProviderSub?.unsubscribe();
  }

  ngOnInit(): void {
    this.loadConversations();
  }

  loadConversations() {
    this.error = undefined;
    this.isLoading = true;

    this.facade
      .getAllConversations(
        this.questionsService.selectedSortListType,
        this.questionsService.selectedGroup,
      )
      .then((conversations) => {
        this.conversations = conversations;
      })
      .catch((err) => {
        this.error = err;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
